import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';
import { Http } from '@angular/http';

export interface Language {
  LanguageId: string;
  [key: string]: string;
}


export interface LanguageConfig {
  [key: string]: string;
}

@Injectable()
export class RegionService {
  private initedSubject: Subject<void>;
  public inited$: Observable<void>;
  public language: LanguageConfig;
  public languages: Language[];

  constructor(
    private http: Http,
    ) {
    this.initedSubject = new Subject();
    this.inited$ = this.initedSubject.asObservable();

    this.languages = [];
  }

  private toJSON(data, divider): any {
    const lineEndings = ['\r', '\n', '\r\n'];

    let newLine;
    lineEndings.forEach(lineEnding => {
      if (data.indexOf(lineEnding) > -1) {
        newLine = lineEnding;
      }
    });

    const lines = data.split(newLine);
    const result = [];
    const headers = lines[0].split(divider);

    for (let i = 1; i < lines.length; i++) {
      const obj = {};
      let skipLine = false;
      const currentline = lines[i].split(divider);
      for (let j = 0; j < headers.length; j++) {
        if (currentline.length > 1) {
          obj[headers[j].trim()] = currentline[j].trim();
        } else {
          skipLine = true;
        }
      }
      if (!skipLine) {
        result.push(obj);
      }
    }

    return result;
  }

  setRegionLanguage(regionKey: string): void {
    // NOTE: LanguageValue is depricated. Pass a default region (e.g. 'us') to getRegionConfig()

    const languageConfig: LanguageConfig = {};
    this.languages.forEach((language: Language) => {
      languageConfig[language.LanguageId] = regionKey ? language[regionKey] : language.LanguageValue;
    });
    this.language = languageConfig;
  }

  init(
    regionKey: string,
    userLocale?: string): Observable<boolean> {
    return new Observable(observer => {
      const filePath = userLocale
      ? './assets/data/language_' + userLocale + '.tsv'
      : './assets/data/language.tsv';
      this.http
      .get(filePath).subscribe(
        data => {
          this.languages = this.toJSON(data.text(), '\t');
          this.setRegionLanguage(regionKey);
          observer.next(true);
          observer.complete();
        },
        error => {
          observer.error(error);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/region.service.ts